export default function Amenities() {
  const amenities = [
    {
      icon: 'ri-water-flash-line',
      title: 'Piscina Adulto e Infantil',
      description: 'Área aquática completa na cobertura'
    },
    {
      icon: 'ri-goblet-line',
      title: 'Bar Molhado',
      description: 'Espaço gourmet para seus momentos'
    },
    {
      icon: 'ri-cake-3-line',
      title: 'Salão de Festas',
      description: 'Celebre com conforto e elegância'
    },
    {
      icon: 'ri-gamepad-line',
      title: 'Salão de Jogos',
      description: 'Entretenimento para toda família'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Lazer na Cobertura',
      description: 'Vista privilegiada e exclusiva'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança 24h',
      description: 'Tranquilidade para você e sua família'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm tracking-[0.3em] uppercase mb-4 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
            Lazer Completo
          </p>
          <h2 className="text-5xl lg:text-6xl font-normal text-gray-900 mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
            Comodidades Exclusivas
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Uma infraestrutura completa de lazer na cobertura, pensada para proporcionar momentos inesquecíveis
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {amenities.map((amenity, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 mb-6 flex items-center justify-center rounded-full bg-amber-50 group-hover:bg-amber-100 transition-all duration-300">
                <i className={`${amenity.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'DM Serif Display, serif' }}>
                {amenity.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {amenity.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl overflow-hidden shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-80 lg:h-auto">
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
